import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  margin-bottom: 24px;
  background-color: #fff;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.03);
`;

const Header = styled.div`
  padding: 16px 24px;
  border-bottom: 2px solid #e9ecef;
  display: flex;
  align-items: center;
  gap: 12px;

  h2 {
    margin: 0;
    font-size: 20px;
  }
`;

const Body = styled.div`
  padding: 24px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 24px;
`;

const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const ItemLabel = styled.span`
  font-size: 14px;
  color: #6c757d;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const ItemValue = styled.span`
  font-size: 16px;
  color: #000;
  font-weight: bold;
`;

const Item = ({ label, value }) => (
  <ItemWrapper>
    <ItemLabel>{label}</ItemLabel>
    <ItemValue>{value ?? '-'}</ItemValue>
  </ItemWrapper>
);

const InfoSection = ({ children, ...props }) => <Container {...props}>{children}</Container>;

InfoSection.Header = ({ title, children, ...props }) => (
  <Header {...props}>
    {title && <h2>{title}</h2>}
    {children}
  </Header>
);

InfoSection.Body = ({ children, ...props }) => <Body {...props}>{children}</Body>;

InfoSection.Item = Item;

export default InfoSection;
